<div class="sale-contact-list-result">
  <div class="table-responsive data-grid sticky-header-table sticky-header-table-height-sm mt-3 p-0" #tableContacts>
    <table [dataSource]="dataSource"
           mat-table
           class="table table-hover"
           infiniteScroll
           [infiniteScrollDistance]="1"
           [infiniteScrollThrottle]="20"
           [infiniteScrollContainer]="tableContacts"
           [fromRoot]="true"
           (scrolled)="onTableScroll()"
           [trackBy]="trackById" matSort="contactSort">
     

      <ng-container matColumnDef="firstName">
        <th mat-header-cell
            class="w-6-rem cursor-pointer"
            *matHeaderCellDef mat-sort-header>
          First <i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.firstName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="lastName">
        <th mat-header-cell
            class="w-6-rem cursor-pointer"
            *matHeaderCellDef mat-sort-header>
          Last <i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.lastName }}
        </td>
      </ng-container>

     

      <ng-container matColumnDef="email">
        <th mat-header-cell
            class="w-8-rem cursor-pointer"
            *matHeaderCellDef mat-sort-header>
          Email <i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.email }}
        </td>
      </ng-container>

      <ng-container matColumnDef="mobile">
        <th mat-header-cell
            class="w-8-rem cursor-pointer "
            *matHeaderCellDef mat-sort-header>
          Phone <i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.countryCode }} {{ element.mobile }}
        </td>
      </ng-container>

   
      <ng-container matColumnDef="linkedLots">
        <th mat-header-cell
            class="w-6-rem cursor-pointer content-center"
            *matHeaderCellDef mat-sort-header>
          Linked {{lotOrHipText}}S<i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell *matCellDef="let element" class="vet-stats-text text-center">
          {{ element.linkedLots }}
        </td>
      </ng-container>



      <ng-container matColumnDef="action">
        <th mat-header-cell
            class="action-heading w-3-rem"
            *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element" ngbDropdown placement="start">
          <a class="btn btn-outline-primary btn-sm me-1"
             (click)="openContactPopup(element)"
             title="Edit Contacts">
            <i class="far fa-edit"></i>
          </a>
         <a class="btn btn-outline-primary btn-sm me-1"
             (click)="deleteContact(element)"
             title="Delete Contact From Sale">
            <i class="fa fa-trash"></i>
          </a>
          <span class="divider"></span>
          <a href="{{ appendShareLinkPrefix(element.contactDownloadLink) }}"
             target="_blank"
             class="btn btn-outline-primary btn-sm btn-view"
             title="Share">
            <i class="fa fa-share-square"></i>
          </a>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns$.value; sticky: true"></tr>
      <tr mat-row
          *matRowDef="
          let row;
          columns: displayedColumns$.value;
          let saleIndex = index
        "
          class="border-start-0 border-end-0 pointer pt-2"></tr>
    </table>

    <!--<div class="row" *ngIf="isLoaderSaleVets">
      <div class="col-md-12 text-center">
        Loading <i class="fa fa-spinner fa-spin"></i>
      </div>
    </div>-->
  </div>
</div>
